import { render, staticRenderFns } from "./SectionContactV1.vue?vue&type=template&id=581e1a16&"
import script from "./SectionContactV1.vue?vue&type=script&lang=js&"
export * from "./SectionContactV1.vue?vue&type=script&lang=js&"
import style0 from "./SectionContactV1.vue?vue&type=style&index=0&id=581e1a16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrganismsProjectOrganismContactForm: require('/app/components/organisms/project/OrganismContactForm.vue').default,AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,OrganismsPortfolioOrganismTeam: require('/app/components/organisms/portfolio/OrganismTeam.vue').default,AtomsCommonAtomButton: require('/app/components/atoms/common/AtomButton.vue').default})
